import { ArrowForward } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { BalootUserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import PageContentContainer from "../../../components/shared/PageContentContainer";

function AutoInvestmentContainer() {
  const navigate = useNavigate();
  const [autoInvestmentStatus, setAutoInvestmentStatus] = useState(null);
  const [autoInvestmentFunds, setAutoInvestmentFunds] = useState([]);

  const {
    loading: statusLoading,
    result: statusResult,
    apiCall: getAutoInvestmentStatus,
  } = useRequest(BalootUserAPIs.getAutoInvestmentStatus, true);
  const {
    loading: fundsLoading,
    result: fundsResult,
    apiCall: getAutoInvestmentFunds,
  } = useRequest(BalootUserAPIs.getAutoInvestmentFunds, true);

  useEffect(() => {
    getAutoInvestmentStatus({
      onSuccess: (response) => {
        setAutoInvestmentStatus(response);
        if (response.items.length === 0 && response.enabled) {
          navigate("add-or-remove", {
            state: { fromContainer: true },
            replace: true,
          });
        } else if (response.items.length !== 0) {
          navigate("status", { replace: true });
        }
      },
    });
    getAutoInvestmentFunds({
      onSuccess: (response) => {
        setAutoInvestmentFunds(response);
      },
    });
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Outlet
        context={{
          autoInvestmentFunds,
          autoInvestmentStatus,
          setAutoInvestmentStatus,
          statusLoading,
          fundsLoading,
          fundsResult,
          statusResult,
        }}
      />
    </Box>
  );
}

export default AutoInvestmentContainer;
